export default __webpack_public_path__ + "static/media/arrow-down-square.2ed498e5.svg";